import { Box, Heading, Text, List, ListItem, Divider, Link, useBreakpointValue, Image, Flex } from "@chakra-ui/react";
import Layout from "../components/layouts/main";
import { motion } from "framer-motion";
import partnershipImg from '../assets/images/png/partnership.png';


const MotionHeading = motion(Heading);
const PartnershipPage = () => {
	const isMobile = useBreakpointValue({ base: true, md: false });

	const commonFontSize = "1rem";  // Define a consistent font size for Text and ListItems

	return (
		<Layout>
			<Box maxW="800px" mx="auto" pb={12}>
				<MotionHeading
					fontSize="clamp(1.5em, 2.8vw, 2.4em)"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 1 }}
					textAlign={"center"}
					m={!isMobile ? 6 : 1}
				>
					Partnership Opportunities
				</MotionHeading>

				<Flex pt={4} pb={6} justifyContent={"center"}>
					<Image src={partnershipImg} borderRadius={15} w={"100%"}></Image>
				</Flex>

				<Text fontSize={commonFontSize} mb={6} pt={2} fontFamily={"Arial, sans-serif"}>
					Join us in expanding our reach! With <strong>over 50,000 unique users</strong> and
					<strong> more than 1,500 daily active users</strong>, our project is rapidly growing and
					attracting attention in the crypto space.
				</Text>

				<Divider my={6} />

				<Heading as="h2" size="lg" mb={4} fontSize="1.5em"> {/* Consistent heading size */}
					Why Partner with Us?
				</Heading>

				<List spacing={4} fontSize={commonFontSize}>
					<ListItem>
						<strong>Fast-growing user base:</strong> Our project is scaling quickly, bringing in new users daily.
					</ListItem>
					<ListItem>
						<strong>Active community:</strong> Our dedicated and engaged audience is interested in innovative projects like yours.
					</ListItem>
					<ListItem>
						<strong>Collaborative spirit:</strong> We're open to exploring a variety of partnership models, whether you're a crypto project looking to exchange audiences or a content creator looking to connect with a tech-savvy community.
					</ListItem>
				</List>

				<Divider my={6} />

				<Heading as="h2" size="lg" mb={4} fontSize="1.5em"> {/* Consistent heading size */}
					We’re Looking for:
				</Heading>

				<List spacing={4} fontSize={commonFontSize}>
					<ListItem>
						<strong>Crypto projects:</strong> Let’s work together to expand our audiences and bring value to both communities.
					</ListItem>
					<ListItem>
						<strong>Bloggers and YouTubers:</strong> If you're a content creator with a passion for crypto and blockchain, we’d love to explore potential collaborations with you!
					</ListItem>
				</List>

				<Divider my={6} />

				<Heading as="h2" size="lg" mb={4} fontSize="1.5em"> {/* Consistent heading size */}
					Get in Touch
				</Heading>

				<Text fontSize={commonFontSize} fontFamily={"Arial, sans-serif"}>
					Interested in collaborating? We're happy to discuss any partnership opportunities. <br />
					Feel free to contact us at <Link href="mailto:partnership@scrollstat.xyz" color="#FF684B">partnership@scrollstat.xyz</Link>.
				</Text>
			</Box>
		</Layout>
	)
}

export default PartnershipPage;
